import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment'
import { StaticPageCreateDto } from '../dtos/staticPage/staticPageCreateDto';
import { StaticPageUpdateDto } from '../dtos/staticPage/staticPageUpdateDto';
import { PageType } from '../enums/pageType';


@Injectable({
  providedIn: 'root'
})
export class StaticPageService {

  constructor(private http: HttpClient) { }
  
  public apiUrl = `${environment.apiUrl}/staticPages`;


  getList() : Observable<any>{
    return this.http.get(`${this.apiUrl}`)
  }

  getById(id:number) : Observable<any>{
    return this.http.get(`${this.apiUrl}/${id}`)
  }

  getByPageType(pageType:PageType) : Observable<any>{
    return this.http.get(`${this.apiUrl}/getByPageTypeAdmin?pageType=${pageType}`)
  }

  create(staticPageCreateDto: StaticPageCreateDto) : Observable<any>{
    return this.http.post(`${this.apiUrl}`, staticPageCreateDto)
  }

  update(id:number, staticPageUpdateDto: StaticPageUpdateDto): Observable<any>{
    return this.http.put(`${this.apiUrl}/${id}`, staticPageUpdateDto)
  }

  delete(id:number): Observable<any>{
    return this.http.delete(`${this.apiUrl}/${id}`)
  }
}
